import { ActivatedRoute } from '@angular/router';
import { Component, HostListener, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Subject } from 'rxjs';

import { AppMemoryService } from '../../core/app-memory.service';
import { DatePipe } from '@angular/common';
import { GetService } from '../../core/get.service';
import { StorageService } from '../../core/storage.service';
import { Horse } from '../../core/classes/horse';
import { Note } from '../../core/classes/note';
import { NotificationsService } from 'angular2-notifications';
import { Treatment } from '../../core/classes/treatment';
import { Vaccination } from 'app/core/classes/vaccination';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { TooltipComponent } from '../../core/tooltip/tooltip.component';
import { NoteInfo } from '../../core/classes/note-info';
import { RouteTypes } from '../../core/types/route-types';
import { DateObjPipe } from 'app/core/pipes/date-obj.pipe';
import { IntraArticularAdditionalInfoA, IntraArticularAdditionalInfoB } from 'app/core/types/intra-articular-info-types';
import { sc24RegionNoteType } from 'app/core/types/note-types';
import { saRegionSc24, saRegionKsa } from 'app/models/Regions';

declare const ImageCompressor: any;

@Component({
  selector: 'app-horse',
  templateUrl: './horse.component.html',
  styleUrls: ['./horse.component.less'],
})
export class HorseComponent implements OnInit {
  @HostListener('document:scroll', ['$event'])
  onWindowScroll() {
    if (this.tabs.isNotes) {
      if (
        $(window).scrollTop() >=
        $(document).height() - $(window).height() - 100
      ) {
        this.addNewData(this.notes);
      }
    }

    if (this.tabs.isVaccinations) {
      if (
        $(window).scrollTop() >=
        $(document).height() - $(window).height() - 100
      ) {
        this.addNewData(this.vaccinations);
      }
    }
  }

  @ViewChild('imageLoader') public imageLoader: any;
  @ViewChild('imageLoader2') public imageLoader2: any;
  @ViewChild('imageLoader22') public imageLoader22: any;
  @ViewChild('imageLoader23') public imageLoader23: any;
  @ViewChild('imageLoader24') public imageLoader24: any;

  @ViewChild('farmsSelector') public farmsSelector: any;

  @ViewChild('measuresSelector') public measuresSelector: any;

  @ViewChild('updateHorseForm') public updateHorseForm: any;

  @ViewChild('createHorseForm') public createHorseForm: any;

  @ViewChild('createTreatmentForm') public createTreatmentForm: any;

  @ViewChild('updateTreatmentForm') public updateTreatmentForm: any;

  @ViewChild('weightsSelector') public weightsSelector: any;

  @ViewChild('noteDescr') public noteDescr: any;

  public maxImgCount = environment.maxImgCount;
  public maxImgSize = environment.maxImgSize;
  public showInTheFoodChainToggle = environment.showInTheFoodChainToggle;

  public drugs: any;

  public objectKeys = Object.keys;

  public horse: Horse;

  public newHorse = new Horse();

  public newTreatment = new Treatment();

  public treatments: Treatments;
  public treatmentsByDate = [] as any;
  public treatmentsByDateArchive = [] as any;

  public currentTreatment: Treatment;
  public currentNote: Note;
  public currentVaccination: Vaccination;

  public _searchStream = new Subject<any>();

  public translation = {};

  public tabs = {
    isTreatments: true as boolean,
    isNotes: false as boolean,
    isVaccinations: false as boolean,
    isHorse: false as boolean,
    isNormalTreatment: true as boolean,
    isQuickTreatment: false as boolean
  };

  public quick_treatment = environment.quick_treatment;

  public newNote = new Note();
  public newVaccination = new Vaccination();

  public farms: Farms | any;

  public notes;

  public noteTypes = [];
  public noteTypeExtraFields = [];
  public treatmentTypes = [];
  public vaccinationNumbers = ['primary', 'secondary', 'booster'];
  public routeTypes = [
    RouteTypes.intraVenous,
    RouteTypes.intraMuscular,
    RouteTypes.intraArticular,
    RouteTypes.oral,
    RouteTypes.other];

  public intraArticularAdditionalInfoA = [
    IntraArticularAdditionalInfoA.left_Fore,
    IntraArticularAdditionalInfoA.right_fore,
    IntraArticularAdditionalInfoA.left_hind,
    IntraArticularAdditionalInfoA.right_hind,
  ];

  public intraArticularAdditionalInfoB = [
    IntraArticularAdditionalInfoB.fetlock,
    IntraArticularAdditionalInfoB.carpus,
    IntraArticularAdditionalInfoB.hock,
    IntraArticularAdditionalInfoB.stifle,
    IntraArticularAdditionalInfoB.other,
  ];

  public serverError = null;
  public serverErrorValidate = null;
  public isRequestInProgress = false;
  public isRequestInProgress2 = false;
  public isRequestInProgress3 = false;
  public isRequestInProgress4 = false;
  public isRequestInProgress5 = false;
  public isRequestSuccess = false;

  public isMicrochipChanged = false;
  public isImagesChanged = false;

  public invalidVaccinationForm = false;
  public invalidTreatmentForm = false;

  public dateRangeErrorMessage: { from?: string, due?: string, date?: string } = {} as { from?: string, due?: string, date?: string };
  public dateRangeTreatmentErrorMessage: { from?: string, due?: string, date?: string } = {} as { from?: string, due?: string, date?: string };
  public dateRangeEditTreatmentErrorMessage: { from?: string, due?: string, date?: string } = {} as { from?: string, due?: string, date?: string };

  public datePicker = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 40)),
    maxDate: new Date() as Date,
    currentDate: new Date() as Date,
    currentDate_input: ''/*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    isActive: false as boolean,
  };

  public datePicker2 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 40)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 40)),
    currentDate: new Date(new Date().setDate(new Date().getDate())),
    currentDate_input: ''/*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    isActive: false as boolean,
  };

  public datePicker3 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3)),
    currentDate: new Date() as Date,
    currentDate_input: /*this.datePipe.transform(new Date(), environment.dateFormat)*/'',
    isActive: false as boolean,
  };

  public datePicker4 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 40)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 40)),
    currentDate: new Date(new Date().setDate(new Date().getDate())),
    currentDate_input: /*this.datePipe.transform(new Date(), environment.dateFormat)*/'',
    isActive: false as boolean,
  };

  public datePicker5 = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3)),
    currentDate: new Date() as Date,
    currentDate_input: ''/*this.datePipe.transform(new Date(), environment.dateFormat)*/,
    isActive: false as boolean,
  };


  public datePickerAddNote = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 3)),
    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 3)),
    currentDate: new Date() as Date,
    currentDate_input: this.datePipe.transform(new Date(), environment.dateFormat),
    isActive: false as boolean,
  };

  public loadSuggestion: boolean;

  public farmSelectModel: Array<Object> = [
    {
      id: null as number,
      text: '' as string,
    },
  ];

  public measuresSelectorModel: any;
  public weightsSelectorModel: any;

  public farmSelectModelLoaded = false;

  public treatmentStatus = {
    request_id: null as number,
    status: '' as string,
    comment: '' as string,
    vetclinic_id: 1 as number, // TO DO
  };

  public pagination = {
    inProgress: false as boolean,
    nextPage: '' as string,
  };
  public paginationTr = {
    inProgress: false as boolean,
    nextPage: '' as string,
  };
  public paginationVc = {
    inProgress: false as boolean,
    nextPage: '' as string,
  };

  public objectToArray(obj: Object) {
    return Object.keys(obj).map(key => obj[key]); // transorm Array-like Object to Array
  }

  public isUserLoaded = false;
  public isAddTreatment = false;

  public vaccinations: any[];

  public maxLength;
  public isShowTooltip: boolean;
  screenHeight;
  screenWidth;
  @ViewChild('addVaccinationTutorial') tooltip: TooltipComponent;

  public selectedTab?: string;
  public hasNoTreatment = false;

  public regionSC24 = saRegionSc24;
  public regionKSA = saRegionKsa;

  public sc24RegionNotes = [];
  public eligible_forms: any;

  /**
   * True when the current horse belongs to the Saudi Arabia (KSA) region.
   * KSA-specific display rules (hidden tabs, relabeled Treatments tab, stripped
   * Add treatment modal) are keyed off this flag and must not affect any other region.
   */
  get isKsaRegion(): boolean {
    return !!(this.horse && this.horse.farm && this.horse.farm.region === this.regionKSA);
  }

  /**
   * Treatment tabs shown on the horse profile. For KSA only Medical Form 1A
   * (treatment type form_1a) is viewable; all other regions are unaffected.
   */
  get visibleTreatmentTabs(): TreatmentTab[] {
    const tabs: TreatmentTab[] = (this.appMemory.static && this.appMemory.static.treatments) || [];
    return this.isKsaRegion ? tabs.filter((tab) => tab.type === 'form_1a') : tabs;
  }

  /**
   * Note tabs shown on the horse profile. For KSA the Vet Info Form (info) and
   * Appointed Vet Exam Form (exam) are hidden; all other regions are unaffected.
   */
  get visibleNoteTabs(): NoteTab[] {
    return this.isKsaRegion
      ? this.noteTypes.filter((tab) => tab.type !== 'info' && tab.type !== 'exam')
      : this.noteTypes;
  }

  constructor(
    private notificationsService: NotificationsService,
    public appMemory: AppMemoryService,
    public getService: GetService,
    public activatedRoute: ActivatedRoute,
    public datePipe: DatePipe,
    public translateService: TranslateService,
    public dateLocalPipe: DateObjPipe,
    private cdr: ChangeDetectorRef,
    private storage: StorageService
  ) { }

  /** Resolve an asset path to a (signed, in s3 mode) URL and open it. */
  public openAsset(imagePath: string) {
    if (!imagePath) { return; }
    this.storage.getDownloadUrl(imagePath).then((url) => window.open(url, '_blank'));
  }

  filterDrugs() {
    this.drugs = this.appMemory.static.drugs.filter((drug: any) =>
      environment.filterRegionForDrugs && !!drug.region
        ? drug.region === this.newHorse.farm.region
        : true
    );

    if (!this.drugs.includes(this.appMemory.static.drugs[0])) {
      this.drugs.unshift(this.appMemory.static.drugs[0]);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  public calcQuantityMaxLength() {
    return 5;
  }

  public calcMaxLength(value) {
    if (value.toString().split('.')[1]) {
      const tmp = value.toString().split('.')[0].length + 3;

      if (tmp < 5) {
        this.maxLength = 5;
      } else {
        this.maxLength = tmp;
      }
    } else {
      this.maxLength = 5;
    }
    // console.log('THIS.MAXLENGTH', this.maxLength);
  }

  getTooltip() {
    return this.isShowTooltip = this.appMemory.getTooltip();
  }

  showTooltip(key, localClass) {
    $('body').removeClass('modal-open');
    $('#add-vaccination').removeClass('open');
    // $('#add-vaccination').trigger('click');
    return this.tooltip.showTooltip(key, localClass);
  }

  getTranslation() {
    this.translateService.get('OTHER.addedSuccess').subscribe((word: string) => {
      this.translation['addedSuccess'] = word;
    });
    this.translateService.get('OTHER.errorOccurred').subscribe((word: string) => {
      this.translation['errorOccurred'] = word;
    });
    this.translateService.get('HORSES.addNote').subscribe((word: string) => {
      this.translation['addNote'] = word;
    });
    this.translateService.get('HORSES.editNote').subscribe((word: string) => {
      this.translation['editNote'] = word;
    });
    this.translateService.get('HORSES.editHorse').subscribe((word: string) => {
      this.translation['editHorse'] = word;
    });
    this.translateService.get('TREATS.addTreat').subscribe((word: string) => {
      this.translation['addTreat'] = word;
    });
    this.translateService.get('TREATS.deleteTreat').subscribe((word: string) => {
      this.translation['deleteTreat'] = word;
    });
    this.translateService.get('OTHER.edittedSuccess').subscribe((word: string) => {
      this.translation['edittedSuccess'] = word;
    });
    this.translateService.get('TREATS.editTreat').subscribe((word: string) => {
      this.translation['editTreat'] = word;
    });
    this.translateService.get('HORSES.note').subscribe((word: string) => {
      this.translation['note'] = word;
    });
    this.translateService.get('HORSES.horse').subscribe((word: string) => {
      this.translation['horse'] = word;
    });
    this.translateService.get('OTHER.uploadImage').subscribe((word: string) => {
      this.translation['uploadImage'] = word;
    });
    this.translateService.get('TREATS.treatment').subscribe((word: string) => {
      this.translation['treatment'] = word;
    });
    this.translateService.get('TREATS.closeTreatment').subscribe((word: string) => {
      this.translation['closeTreatment'] = word;
    });
    this.translateService.get('HORSES.addVacs').subscribe((word: string) => {
      this.translation['addVacs'] = word;
    });
    this.translateService.get('OTHER.deletedSuccess').subscribe((word: string) => {
      this.translation['deletedSuccess'] = word;
    });
    this.translateService.get('TREATS.treatmentStatus').subscribe((word: string) => {
      this.translation['treatmentStatus'] = word;
    });
    this.translateService.get('TREATS.updateTreatmentStatus').subscribe((word: string) => {
      this.translation['updateTreatmentStatus'] = word;
    });
    this.translateService.get('OTHER.updatedSuccess').subscribe((word: string) => {
      this.translation['updatedSuccess'] = word;
    });
    this.translateService.get('HORSES.delectVacc').subscribe((word: string) => {
      this.translation['delectVacc'] = word;
    });
    this.translateService.get('HORSES.vacc').subscribe((word: string) => {
      this.translation['vacc'] = word;
    });
    this.translateService.get('HORSES.archiveHorse').subscribe((word: string) => {
      this.translation['archiveHorse'] = word;
    });
    this.translateService.get('HORSES.wasAlreadyDeleted').subscribe((word: string) => {
      this.translation['wasAlreadyDeleted'] = word;
    });
    this.translateService.get('HORSES.deleteNote').subscribe((word: string) => {
      this.translation['deleteNote'] = word;
    });
    this.translateService.get('OTHER.archivedSuccess').subscribe((word: string) => {
      this.translation['archivedSuccess'] = word;
    });
    this.translateService.get('OTHER.isNotEligible').subscribe((word: string) => {
      this.translation['isNotEligible'] = word;
    });
    this.translateService.get('HORSES.description').subscribe((word: string) => {
      this.translation['description'] = word;
    });
    this.translateService.get('CORE.invalidDate').subscribe((word: string) => {
      this.translation['invalidDate'] = word;
    });
    this.translateService.get('OTHER.comments.review_consent').subscribe((word: string) => {
      this.translation['comments.review_consent'] = word;
    });
    this.translateService.get('OTHER.comments.inspection_consent').subscribe((word: string) => {
      this.translation['comments.inspection_consent'] = word;
    });
    this.translateService.get('OTHER.comments.travel_consent').subscribe((word: string) => {
      this.translation['comments.travel_consent'] = word;
    });
    this.translateService.get('OTHER.comments.musculoskeletal').subscribe((word: string) => {
      this.translation['comments.musculoskeletal'] = word;
    });
    this.translateService.get('OTHER.comments.feet').subscribe((word: string) => {
      this.translation['comments.feet'] = word;
    });
    this.translateService.get('OTHER.comments.surface').subscribe((word: string) => {
      this.translation['comments.surface'] = word;
    });
    this.translateService.get('OTHER.comments.other').subscribe((word: string) => {
      this.translation['comments.other'] = word;
    });
    this.translateService.get('OTHER.comments.images').subscribe((word: string) => {
      this.translation['comments.images'] = word;
    });
    this.translateService.get('OTHER.images').subscribe((word: string) => {
      this.translation['images'] = word;
    });
  }

  /**
   *
   * @param excludeHorse
   * @param excludeTreatments
   * @param excludeNotes
   * @param excludeVaccination
   */
  getHorseByUserRole(
    {
      excludeHorse = false,
      excludeTreatments = false,
      excludeNotes = false,
      excludeVaccination = true,
    } = {} as any
  ) {
    const { roles: [{ id: roleId } = {} as Role] = [] } = this.appMemory.user || {};

    let horseCall;
    let notesCall;

    switch (roleId) {
      case 1:
        horseCall = this.getHorse.bind(this);
        notesCall = this.getNotes.bind(this, '/instructor');
        break;

      case 2:
        horseCall = this.getHorseA.bind(this);
        notesCall = this.getNotes.bind(this, '/assistant');
        break;

      case 3:
        horseCall = this.getHorseV.bind(this);
        notesCall = this.getNotes.bind(this, '/vet');
        break;
    }

    if (!excludeHorse) {
      horseCall();
    }

    if (!excludeTreatments) {
      this.getHorse('/treatments', this.selectedTab);
    }

    if (!excludeNotes) {
      notesCall(this.selectedTab);
    }

    if (!excludeVaccination) {
      this.getVaccinations();
    }
  }

  set _horse(value: Horse) {
    if (value && value.farm.region == this.regionSC24) {

      var alreadyExists = this.noteTypes.find(note => note.type == sc24RegionNoteType.type_pre_travel_declaration
        || note.type == sc24RegionNoteType.type_veterinary_inspection);

      if (this.noteTypes && !alreadyExists) {
        this.noteTypes = this.noteTypes.filter((note) => note.type != "info");

        this.noteTypes = this.noteTypes.concat(this.sc24RegionNotes);

        this.cdr.detectChanges();
      }
    }
  }

  ngOnInit(): void {
    this._searchStream.debounceTime(200).subscribe((res) => {
      if (res && res.length > 0) {
        this.getFarms(res);
      }
    });

    this.appMemory.staticLoaded.subscribe((val) => {
      // tslint:disable-next-line:curly
      if (!val) return;
      this.noteTypes = this.appMemory.static.notes;
      this.sc24RegionNotes = this.appMemory.static.sc24RegionNotes;
      this.treatmentTypes = this.appMemory.static.treatments;
    });

    this.appMemory.staticLoaded.subscribe((val) => {
      // tslint:disable-next-line:curly
      if (!val) return;

      this.appMemory.userSubject.subscribe((e) => {
        if (this.appMemory.user && e && !this.isUserLoaded) {
          this.getHorseByUserRole({
            excludeNotes: true,
            excludeTreatments: true,
          });
          this.setTab(this.appMemory.static.treatments[0]);
          this.isUserLoaded = true;
        }
      });
    });

    this.getTranslation();
    this.getFarms();
  }

  debug(e) {
    console.log(e);
  }

  searchDrugs(e) {
    this.drugs = [];
    this.drugs[0] = this.appMemory.static.drugs[0];
    if (this.appMemory.static.drugs) {
      this.appMemory.static.drugs.forEach((el, i) => {
        if (
          el.name.toLowerCase().indexOf(e.toLowerCase()) !== -1 &&
          el.name.toLowerCase().indexOf(this.drugs[0].name.toLowerCase()) === -1
        ) {
          this.drugs.push(el);
        }
      });
    }
  }

  getHorse(option?: string, extra?: string) {
    if (option === '/treatments') {
      this.isRequestInProgress2 = true;
    }

    this.getService
      .getHorse(this.activatedRoute.params['value']['horse_id'], option, extra)
      .then(
        (res: any) => {
          switch (option) {
            case '/treatments':
              if (res.alive) {
                res.alive.sort((a, b) => {
                  const d1 = new Date(a.updated_at);
                  const d2 = new Date(b.updated_at);
                  // (( ( a.request && b.request && b.request.status.toLowerCase() == a.request.status.toLowerCase() ) || (!b.request && !a.request) ) ?  : 0)
                  // return (d2.getTime() > d1.getTime() ? 1 : -1);
                  if (!a.request && !b.request) {
                    return d2.getTime() > d1.getTime() ? 1 : -1;
                  } else if (a.request && b.request) {
                    if (
                      b.request.status.toLowerCase() !==
                      a.request.status.toLowerCase()
                    ) {
                      let f;
                      switch (b.request.status.toLowerCase()) {
                        case 'pending':
                          f = 1;
                          break;
                        case 'cancelled':
                          f = -1;
                          break;
                        case 'approved':
                          if (a.request.status.toLowerCase() === 'pending') {
                            f = -1;
                          } else {
                            f = 1;
                          }
                          break;
                      }
                      return f;
                    } else {
                      return d2.getTime() > d1.getTime() ? 1 : -1;
                    }
                  } else {
                    let f;
                    if (!b.request) {
                      if (a.request.status.toLowerCase() === 'approved') {
                        f = d2.getTime() > d1.getTime() ? 1 : -1;
                      } else if (a.request.status.toLowerCase() === 'pending') {
                        f = -1;
                      } else {
                        f = 1;
                      }
                    } else {
                      if (b.request.status.toLowerCase() === 'approved') {
                        f = d2.getTime() > d1.getTime() ? 1 : -1;
                      } else if (b.request.status.toLowerCase() === 'pending') {
                        f = 1;
                      } else {
                        f = -1;
                      }
                    }
                    return f;
                  }
                });
              }
              this.treatments = res;
              this.sortArrayByDate(this.treatments.alive, 'alive');
              this.sortArrayByDate(this.treatments.archive.data, 'archive');
              this.paginationTr.nextPage = this.treatments.archive.next_page_url;
              break;

            default:
              this.horse = res;
              this._horse = res;

              if (this.horse.eligible_forms) {
                this.eligible_forms = JSON.parse(this.horse.eligible_forms);
              }
              
              this.appMemory.horse = this.horse;
              this.appMemory.pageInfo.title = this.horse.name || `${this.translation['horse']}`;
              this.newHorse = Object.assign({}, this.horse);

              var dateLocalPipe = this.dateLocalPipe.transform(this.newHorse.birth);
              this.datePicker.currentDate_input = this.datePipe.transform(dateLocalPipe, environment.dateFormat);
              this.datePicker.currentDate = dateLocalPipe;

              // this.datePicker.currentDate_input = this.datePipe.transform((new Date(this.newHorse.birth)), environment.dateFormat);
              // this.datePicker.currentDate = new Date(this.newHorse.birth);

              this.farmSelectModel[0]['id'] = this.newHorse.farm.id;
              this.farmSelectModel[0]['text'] = this.newHorse.farm.name;

              this.farmSelectModelLoaded = true;

              setTimeout(() => {
                if (this.horse.microchip) {
                  this.imageLoader.files[0] = new File([''], 'microchip');
                  this.imageLoader.files[0].src = this.horse.microchip;
                  this.imageLoader.fileChange(this.imageLoader.files[0]);
                  this.imageLoader.fileCounter = 1;
                }
              });

              this.appMemory.pageInfo.title = this.horse.name || `${this.translation['horse']}`;
              this.appMemory.pageInfo.isHorse = true;
          }
          this.isRequestInProgress2 = false;
        },
        (err: any) => {
          console.log('ERR', err);
          this.isRequestInProgress2 = false;
        }
      );
  }

  getHorseA(option?: string) {
    if (option === '/treatments') {
      this.isRequestInProgress2 = true;
    }

    this.getService
      .getHorseA(this.activatedRoute.params['value']['horse_id'], option)
      .then(
        (res: any) => {
          switch (option) {
            case '/treatments':
              if (res.alive) {
                res.alive.sort((a, b) => {
                  const d1 = new Date(a.updated_at);
                  const d2 = new Date(b.updated_at);
                  // (( ( a.request && b.request && b.request.status.toLowerCase() == a.request.status.toLowerCase() ) || (!b.request && !a.request) ) ?  : 0)
                  // return (d2.getTime() > d1.getTime() ? 1 : -1);
                  if (!a.request && !b.request) {
                    return d2.getTime() > d1.getTime() ? 1 : -1;
                  } else if (a.request && b.request) {
                    if (
                      b.request.status.toLowerCase() !==
                      a.request.status.toLowerCase()
                    ) {
                      let f;
                      switch (b.request.status.toLowerCase()) {
                        case 'pending':
                          f = 1;
                          break;
                        case 'cancelled':
                          f = -1;
                          break;
                        case 'approved':
                          if (a.request.status.toLowerCase() === 'pending') {
                            f = -1;
                          } else {
                            f = 1;
                          }
                          break;
                      }
                      return f;
                    } else {
                      return d2.getTime() > d1.getTime() ? 1 : -1;
                    }
                  } else {
                    let f;
                    if (!b.request) {
                      if (a.request.status.toLowerCase() === 'approved') {
                        f = d2.getTime() > d1.getTime() ? 1 : -1;
                      } else if (a.request.status.toLowerCase() === 'pending') {
                        f = -1;
                      } else {
                        f = 1;
                      }
                    } else {
                      if (b.request.status.toLowerCase() === 'approved') {
                        f = d2.getTime() > d1.getTime() ? 1 : -1;
                      } else if (b.request.status.toLowerCase() === 'pending') {
                        f = 1;
                      } else {
                        f = -1;
                      }
                    }
                    return f;
                  }
                });
              }

              this.treatments = res;
              this.sortArrayByDate(this.treatments.alive, 'alive');
              this.sortArrayByDate(this.treatments.archive.data, 'archive');
              this.paginationTr.nextPage = this.treatments.archive.next_page_url;
              break;

            default:
              this.horse = res;
              this._horse = res;

              if (this.horse.eligible_forms) {
                this.eligible_forms = JSON.parse(this.horse.eligible_forms);
              }
              
              this.appMemory.horse = this.horse;
              this.newHorse = Object.assign({}, this.horse);

              this.farmSelectModel[0]['id'] = this.newHorse.farm.id;
              this.farmSelectModel[0]['text'] = this.newHorse.farm.name;

              this.farmSelectModelLoaded = true;

              setTimeout(() => {
                if (this.horse.microchip) {
                  this.imageLoader.files[0] = new File([''], 'microchip');
                  this.imageLoader.files[0].src = this.horse.microchip;
                  this.imageLoader.fileChange(this.imageLoader.files[0]);
                  this.imageLoader.fileCounter = 1;
                }
              });

              this.appMemory.pageInfo.title = this.horse.name || `${this.translation['horse']}`;
              this.appMemory.pageInfo.isHorse = true;
          }
          this.isRequestInProgress2 = false;
        },
        (err: any) => {
          console.log('ERR', err);
          this.isRequestInProgress2 = false;
        }
      );
  }

  getHorseV(option?: string) {
    if (option === '/treatments') {
      this.isRequestInProgress2 = true;
    }

    this.getService
      .getHorseV(this.activatedRoute.params['value']['horse_id'], option)
      .then(
        (res: any) => {
          switch (option) {
            case '/treatments':
              if (res.alive) {
                res.alive.sort((a, b) => {
                  const d1 = new Date(a.updated_at);
                  const d2 = new Date(b.updated_at);
                  // (( ( a.request && b.request && b.request.status.toLowerCase() == a.request.status.toLowerCase() ) || (!b.request && !a.request) ) ?  : 0)
                  // return (d2.getTime() > d1.getTime() ? 1 : -1);
                  if (!a.request && !b.request) {
                    return d2.getTime() > d1.getTime() ? 1 : -1;
                  } else if (a.request && b.request) {
                    if (
                      b.request.status.toLowerCase() !==
                      a.request.status.toLowerCase()
                    ) {
                      let f;
                      switch (b.request.status.toLowerCase()) {
                        case 'pending':
                          f = 1;
                          break;
                        case 'cancelled':
                          f = -1;
                          break;
                        case 'approved':
                          if (a.request.status.toLowerCase() === 'pending') {
                            f = -1;
                          } else {
                            f = 1;
                          }
                          break;
                      }
                      return f;
                    } else {
                      return d2.getTime() > d1.getTime() ? 1 : -1;
                    }
                  } else {
                    let f;
                    if (!b.request) {
                      if (a.request.status.toLowerCase() === 'approved') {
                        f = d2.getTime() > d1.getTime() ? 1 : -1;
                      } else if (a.request.status.toLowerCase() === 'pending') {
                        f = -1;
                      } else {
                        f = 1;
                      }
                    } else {
                      if (b.request.status.toLowerCase() === 'approved') {
                        f = d2.getTime() > d1.getTime() ? 1 : -1;
                      } else if (b.request.status.toLowerCase() === 'pending') {
                        f = 1;
                      } else {
                        f = -1;
                      }
                    }
                    return f;
                  }
                });
              }

              this.treatments = res;
              this.sortArrayByDate(this.treatments.alive, 'alive');
              this.sortArrayByDate(this.treatments.archive.data, 'archive');
              this.paginationTr.nextPage = this.treatments.archive.next_page_url;
              break;

            default:
              this.horse = res;
              this._horse = res;

              if (this.horse.eligible_forms) {
                this.eligible_forms = JSON.parse(this.horse.eligible_forms);
              }              

              this.appMemory.horse = this.horse;
              this.newHorse = Object.assign({}, this.horse);

              this.farmSelectModel[0]['id'] = this.newHorse.farm.id;
              this.farmSelectModel[0]['text'] = this.newHorse.farm.name;

              this.farmSelectModelLoaded = true;

              setTimeout(() => {
                if (this.horse.microchip) {
                  this.imageLoader.files[0] = new File([''], 'microchip');
                  this.imageLoader.files[0].src = this.horse.microchip;
                  this.imageLoader.fileChange(this.imageLoader.files[0]);
                  this.imageLoader.fileCounter = 1;
                }
              });

              this.appMemory.pageInfo.title = this.horse.name || `${this.translation['horse']}`;
              this.appMemory.pageInfo.isHorse = true;
          }
          this.isRequestInProgress2 = false;
        },
        (err: any) => {
          console.log('ERR', err);
          this.isRequestInProgress2 = false;
        }
      );
  }

  sortArrayByDate(array: any, type: string) {
    this.isRequestInProgress2 = true;

    switch (type) {
      case 'alive':
        this.treatmentsByDate = [];

        let tmp = undefined;
        array.forEach((e, i) => {
          e.date = e.start_date; // .slice(0, -9);
          if (!tmp) {
            e.data = [e];
            tmp = e;
            if (i === array.length - 1) {
              this.treatmentsByDate.push(tmp);
              tmp = undefined;
            }
          } else {
            if (e.date === tmp.date) {
              tmp.data.push(e);
              if (i === array.length - 1) {
                this.treatmentsByDate.push(tmp);
                tmp = undefined;
              }
            } else {
              this.treatmentsByDate.push(tmp);
              tmp = undefined;
              e.data = [e];
              tmp = e;
              if (i === array.length - 1) {
                this.treatmentsByDate.push(tmp);
                tmp = undefined;
              }
            }
          }
        });
        if (tmp) {
          this.treatmentsByDate.push(tmp);
          tmp = undefined;
        }
        break;

      case 'archive':
        this.treatmentsByDateArchive = [];

        let tmp2 = undefined;
        array.forEach((e, i) => {
          e.date = e.start_date; // .slice(0, -9);
          if (!tmp2) {
            e.data = [e];
            tmp2 = e;
            if (i === array.length - 1) {
              this.treatmentsByDateArchive.push(tmp2);
              tmp2 = undefined;
            }
          } else {
            if (e.date === tmp2.date) {
              tmp2.data.push(e);
              if (i === array.length - 1) {
                this.treatmentsByDateArchive.push(tmp2);
                tmp2 = undefined;
              }
            } else {
              this.treatmentsByDateArchive.push(tmp2);
              tmp2 = undefined;
              e.data = [e];
              tmp2 = e;
              if (i === array.length - 1) {
                this.treatmentsByDateArchive.push(tmp2);
                tmp2 = undefined;
              }
            }
          }
        });
        if (tmp2) {
          this.treatmentsByDateArchive.push(tmp2);
          tmp2 = undefined;
        }
        break;
    }

    this.isRequestInProgress2 = false;
  }

  getNotes(role: string, type?: string) {
    this.isRequestInProgress3 = true;
    this.notes = [];
    this.getService
      .getNotes(this.activatedRoute.params['value']['horse_id'], role, type)
      .then(
        (res: any) => {
          this.notes = res.data;

          if (res.next_page_url) {
            this.pagination.nextPage = res.next_page_url;
          } else {
            this.pagination.nextPage = res.next_page_url;
          }

          this.isRequestInProgress3 = false;
        },
        (err: any) => {
          console.log('ERR', err);
          this.isRequestInProgress3 = false;
        }
      );
  }

  addNewData(items: any) {
    if (this.tabs.isNotes) {
      if (
        this.pagination.nextPage === null ||
        this.pagination.inProgress ||
        this.pagination.nextPage === ''
      ) {
        return;
      }

      this.pagination.inProgress = true;
      this.getService.rawRequest(this.pagination.nextPage).then(
        (res: any) => {
          res.data.forEach((item: any) => {
            items.push(item);
          });

          if (res.next_page_url) {
            this.pagination.nextPage = res.next_page_url;
          } else {
            this.pagination.nextPage = res.next_page_url;
          }

          this.pagination.inProgress = false;
        },
        (err: any) => {
          this.pagination.inProgress = false;
        }
      );
    } else if (this.tabs.isTreatments) {
      if (
        this.paginationTr.nextPage === null ||
        this.paginationTr.inProgress ||
        this.paginationTr.nextPage === ''
      ) {
        return;
      }

      this.paginationTr.inProgress = true;

      this.getService.rawRequest(this.paginationTr.nextPage).then(
        (res: any) => {
          let tmp2 = undefined;
          let tmp3 = this.treatmentsByDateArchive[
            this.treatmentsByDateArchive.length - 1
          ];
          const array = res.archive.data;
          array.forEach((e, i) => {
            e.date = e.updated_at; // .slice(0, -9);
            if (tmp3 && tmp3.date === e.date) {
              this.treatmentsByDateArchive[
                this.treatmentsByDateArchive.length - 1
              ].data.push(e);
            } else {
              tmp3 = undefined;
              if (!tmp2) {
                e.data = [e];
                tmp2 = e;
                if (i === array.length - 1) {
                  this.treatmentsByDateArchive.push(tmp2);
                  tmp2 = undefined;
                }
              } else {
                if (e.date === tmp2.date) {
                  tmp2.data.push(e);
                  if (i === array.length - 1) {
                    this.treatmentsByDateArchive.push(tmp2);
                    tmp2 = undefined;
                  }
                } else {
                  this.treatmentsByDateArchive.push(tmp2);
                  tmp2 = undefined;
                  e.data = [e];
                  tmp2 = e;
                  if (i === array.length - 1) {
                    this.treatmentsByDateArchive.push(tmp2);
                    tmp2 = undefined;
                  }
                }
              }
            }
          });
          if (tmp2) {
            this.treatmentsByDateArchive.push(tmp2);
            tmp2 = undefined;
          }
          this.paginationTr.nextPage = res.archive.next_page_url;

          this.paginationTr.inProgress = false;
        },
        (err: any) => {
          this.paginationTr.inProgress = false;
        }
      );
    } else if (this.tabs.isVaccinations) {
      if (
        this.paginationVc.nextPage === null ||
        this.paginationVc.inProgress ||
        this.paginationVc.nextPage === ''
      ) {
        return;
      }

      this.paginationVc.inProgress = true;
      this.getService.rawRequest(this.paginationVc.nextPage).then(
        (res: any) => {
          res.data.forEach((item: any) => {
            items.push(item);
          });

          if (res.next_page_url) {
            this.paginationVc.nextPage = res.next_page_url;
          } else {
            this.paginationVc.nextPage = res.next_page_url;
          }

          this.paginationVc.inProgress = false;
        },
        (err: any) => {
          this.paginationVc.inProgress = false;
        }
      );
    }
  }

  createNote(role: string, form: any) {
    if (
      form.form.invalid ||
      (this.newNote.type === 'weight' && !this.newNote.weight)
    ) {
      return;
    }

    // The modal's note type picker can point at a different form than the tab it
    // was opened from, so re-check the lock against the type actually submitted.
    if (this.isFormAlreadyEligibleCheckByType(this.newNote.type || this.selectedTab)) {
      return;
    }

    const formData: FormData = new FormData();

    this.isRequestInProgress = true;

    Object.keys(this.newNote)
      .filter((key) => !['src'].includes(key))
      .forEach((key) => {
        formData.append(key, this.newNote[key]);
      });

    if (!this.newNote.type) {
      this.newNote.type = this.selectedTab;
    }

    formData.append('type', this.newNote.type);

    if (this.newNote.type !== 'weight') {
      delete this.newNote.weight;
    } else {
      formData.append('weight', this.newNote.weight);
    }

    formData.append('title', this.newNote.title || '');
    formData.append('description', this.newNote.description || '');

    if (this.newNote.date === undefined) {
      this.setNoteDate(new Date());
    }

    formData.append('date', this.newNote.date);

    let needsS3Upload = false;
    if (this.newNote.src && this.isImagesChanged) {
      const imgs = $('.with_description .image-container .image');
      this.newNote.src.forEach((e, i) => {
        formData.append(
          'images[' + i + '][description]',
          $(imgs[i]).find('input').val()
        );
      });
      needsS3Upload = this.storage.appendFilesToForm(
        formData, 'images', this.newNote.src, null, true);
    }

    this.getService
      .addNote(
        this.activatedRoute.params['value']['horse_id'],
        role,
        formData
      )
      .then((res: any) => {
        if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
          return this.storage.putToS3(res.presigned_urls, this.newNote.src).then(() => res);
        }
        return res;
      })
      .then(
        (res: any) => {
          $('#assistant-invite-email-box').removeClass('input--filled');
          this.clearUserInput(form);
          this.hideModal();
          this.notes = [];

          var param = {
            excludeHorse: true,
            excludeTreatments: true,
            excludeNotes: false,
          }

          this.getHorseByUserRole(param);
          this.isRequestInProgress = false;
          this.notificationsService.success(
            `${this.translation['addNote']}`,
            `${this.translation['note']} ${this.translation['addedSuccess']}`
          );
        }
      )
      .catch((err: any) => {
          this.isRequestInProgress = false;
          this.notificationsService.error(
            `${this.translation['addNote']}`,
            err._body && JSON.parse(err._body)
              ? `${this.objectToArray(JSON.parse(err._body))}`
              : `${this.translation['errorOccurred']}`
          );
        }
      );

  }

  updateNote(role: string, form: any) {
    this.isRequestInProgress = true;

    const formData: FormData = new FormData();

    Object.keys(this.newNote)
      .forEach((key) => {
        // tslint:disable-next-line:curly
        if (['user', 'horse', 'images'].includes(key)) return;
        formData.append(key, this.newNote[key]);
      });

    if (!this.newNote.type) {
      this.newNote.type = this.selectedTab;
    }

    formData.append('type', this.newNote.type);

    if (this.newNote.type !== 'weight') {
      delete this.newNote.weight;
    } else {
      formData.append('weight', this.newNote.weight);
    }

    formData.append('title', this.newNote.title || '');
    formData.append('description', this.newNote.description || '');

    if (this.newNote.date) {
      formData.append('date', this.newNote.date);
    }

    if (this.newNote.images) {
      const del = [];
      this.newNote.images.forEach(el => {
        let flag = true;
        this.newNote.srcs.forEach(el2 => {
          if (flag && el2.id === el.id) {
            flag = false;
          }
        });
        if (flag) {
          del.push(el.id);
        }
      });
      if (del.length > 0) {
        const requestObj = {};
        switch (role) {
          case '/vet':
            requestObj['url'] =
              '/note-request-vet/' + this.newNote.id;
            break;
          case '/assistant':
            requestObj['url'] = '/note-request/' + this.newNote.id;
            break;
          case '/instructor':
            requestObj['url'] = '/instructor/note/' + this.newNote.id;
            break;
        }
        requestObj['params'] = { 'images[]': del };
        this.getService.removeImages(requestObj).then(
          res => {
            this.getHorseByUserRole();
          },
          err => {
            // console.log(err);
          }
        );
      }
    }

    let needsS3Upload = false;
    if (this.newNote.src && this.isImagesChanged) {
      const imgs = $('.with_description .image-container .image');
      this.newNote.src.forEach((e, i) => {
        formData.append(
          'images[' + i + '][description]',
          $(imgs[i])
            .find('input')
            .val()
        );
      });
      needsS3Upload = this.storage.appendFilesToForm(
        formData, 'images', this.newNote.src, null, true);
    }
    // tslint:disable-next-line:one-line
    else {
      formData.append('images_exists', true);
    }

    this.getService
      .updateNoteById(
        this.activatedRoute.params['value']['horse_id'],
        role,
        // this.newNote
        formData,
        this.newNote.id
      )
      .then((res: any) => {
        if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
          return this.storage.putToS3(res.presigned_urls, this.newNote.src).then(() => res);
        }
        return res;
      })
      .then(
        (res: any) => {
          $('#assistant-invite-email-box').removeClass('input--filled');
          this.clearUserInput(form);
          this.hideModal();
          this.notes = [];

          var param = {
            excludeHorse: true,
            excludeTreatments: true,
            excludeNotes: false,
          }

          this.getHorseByUserRole(param);
          this.isRequestInProgress = false;
          this.notificationsService.success(
            `${this.translation['editNote']}`,
            `${this.translation['note']} ${this.translation['edittedSuccess']}`
          );
        }
      )
      .catch((err: any) => {
          console.log('ERR', err._body);


          this.isRequestInProgress = false;
          this.notificationsService.error(
            `${this.translation['editNote']}`,
            `${this.translation['errorOccurred']} ${this.processServerError(err)}`
          );
        }
      );
  }

  clearUserInput(form?: any, close?: boolean) {
    this.clearImages();
    this.serverError = null;
    this.serverErrorValidate = null;
    if (form) {
      form.resetForm();
    }
    this.newNote = new Note();
    this.newTreatment = new Treatment();
    this.newVaccination = new Vaccination();
    this.measuresSelectorModel = [];
    this.weightsSelectorModel = [];
    this.hasNoTreatment = false;

    $('#note-title-box').removeClass('input--filled');
    $('#note-descr-box').removeClass('input--filled');
    $('#comment-box').removeClass('input--filled');
    $('#quantity-box').removeClass('input--filled');
    $('#reason-box').removeClass('input--filled');
    /*$('#detection_time-box').removeClass('input--filled');*/
    $('#duration-box').removeClass('input--filled');
    $('#microchip-number-box').removeClass('input--filled');
    this.dateRangeErrorMessage = {} as { from?: string, due?: string, date?: string };
    this.dateRangeTreatmentErrorMessage = {} as { from?: string, due?: string, date?: string };
    this.dateRangeEditTreatmentErrorMessage = {} as { from?: string, due?: string, date?: string };
    this.datePicker.isActive = false;
    this.datePicker2.isActive = false;
    this.datePicker3.isActive = false;
    this.datePicker4.isActive = false;
    this.datePicker5.isActive = false;
    this.datePickerAddNote.isActive = false;
    this.isAddTreatment = false;
  }

  addNodeSetDefaultDate() {
    this.datePickerAddNote.currentDate_input = this.datePipe.transform(new Date(), environment.dateFormat);
  }

  hideModal(noclear?: boolean) {
    if (!noclear) {
      this.clearImages();
    }
    $('.modal.open').removeClass('open');
    $('body').removeClass('modal-open');
  }
  clearImages() {
    if (this.imageLoader22) {
      this.imageLoader22.deleteAll();
    }
    if (this.imageLoader2) {
      this.imageLoader2.deleteAll();
    }
    if (this.imageLoader23) {
      this.imageLoader23.deleteAll();
    }
    if (this.imageLoader24) {
      this.imageLoader24.deleteAll();
    }
  }

  getFarms(name?: string) {
    if (!this.farmsSelector) {
      this.farmsSelector = {
        items: []
      };
    } else {
      this.farmsSelector.items = [];
    }
    this.loadSuggestion = true;
    if (name) {
      return this.farms = this.farms.filter(farm => new RegExp('.*' + name + '.*').test(farm.name));
    }
    return this.getService.getAllFarms().then(res => {
      res.forEach(e => {
        e.text = e.name;
      });

      this.farms = res;
      this.loadSuggestion = false;

      setTimeout(() => {
        // this.farmsSelector.open();
      }, 100);
    },
      err => {
        this.loadSuggestion = false;
      }
    );
  }

  setFarmId(e) {
    this.newHorse.farm_id = e.id;
  }

  setMeasure(e) {
    this.newTreatment.quantity_measure = e.id;
  }

  setWeight(e) {
    this.newNote.weight = e.text;
  }

  setImage(file: File) {
    const that = this;
    new ImageCompressor(file, {
      maxWidth: 1000,
      maxHeight: 668,
      success(result) {
        that.newHorse.microchip = result;
        that.isMicrochipChanged = true;
      },
      error(e) {
        console.log(e.message);
        that.notificationsService.error(
          `${this.translation['uploadImage']}`,
          `${this.translation['errorOccurred']}`
        );
      },
    });
  }

  setNoteImages(file: File[]) {
    const that = this;

    this.newNote.src = file;
    this.isImagesChanged = true;


    setTimeout(() => {
      for (let i = 0; i < file.length; i++) {

        if (!(<any>file[i]).compressed) {
          new ImageCompressor((<any>file[i]).file, {
            maxWidth: 1000,
            maxHeight: 668,
            success(result) {
              (<any>file[i]).file = result;
              (<any>file[i]).compressed = true;
            },
            error(e) {
              // console.log(e.message);
              // that.notificationsService.error(
              //     `${this.translation['uploadImage']}`,
              //     `${this.translation['errorOccurred']}`
              // );
            },
          });

        }
      }


      const imgs = $('.with_description .image-container .image');
      imgs.addClass('image-block');

      imgs.each(i => {
        if ($(imgs[i]).find('.remove_on_remove_img').length === 0) {
          const a = `<div class="box-control remove_on_remove_img">
              <input type="text"
                     class="form-control input__field"
                     name="image_description_${i}"
                     autocomplete="off">
              <label class="input__label">
                <span>${this.translation['description']}</span>
              </label>
            </div>`;
          $(a).appendTo(imgs[i]);
        }
      });
    }, 200);
  }

  setImages(file: File[]) {
    const that = this;

    this.newTreatment.src = file;
    this.isImagesChanged = true;


    setTimeout(() => {
      for (let i = 0; i < file.length; i++) {
        if ((<any>file[i]).file.type === 'image/jpg' || (<any>file[i]).file.type === 'image/png') {
          if (!(<any>file[i]).compressed) {
            new ImageCompressor((<any>file[i]).file, {
              maxWidth: 1000,
              maxHeight: 668,
              success(result) {
                (<any>file[i]).file = result;
                (<any>file[i]).compressed = true;
              },
              error(e) {
                console.log(e.message);
                that.notificationsService.error(
                  `${this.translation['uploadImage']}`,
                  `${this.translation['errorOccurred']}`
                );
              },
            });
          }
        }
      }


      const imgs = $('.with_description .image-container .image');
      imgs.addClass('image-block');

      imgs.each(i => {
        if ($(imgs[i]).find('.remove_on_remove_img').length === 0) {
          const a = `<div class="box-control remove_on_remove_img">
              <input type="text"
                     class="form-control input__field"
                     name="image_description_${i}"
                     autocomplete="off">
              <label class="input__label">
                <span>${this.translation['description']}</span>
              </label>
            </div>`;
          $(a).appendTo(imgs[i]);
        }
      });
    }, 200);
  }

  public datePickerMask = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  };

  formatDate(date) {
    if (date) {
      const arr = date.split('/');
      switch (environment.dateFormat) {
        case 'MM/dd/yyyy':
          return arr[0] + '/' + arr[1] + '/' + arr[2];
        case 'dd/MM/yyyy':
        default:
          return arr[1] + '/' + arr[0] + '/' + arr[2];
      }
    }
  }

  setNoteDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.note_date = null;
    }
    this.newNote.date = this.datePipe
      .transform(date, 'yyyy-MM-dd')
      .replace(/\s/g, 'T');
    this.datePickerAddNote.currentDate = date;
    this.datePickerAddNote.currentDate_input = this.datePipe.transform(date, environment.dateFormat);
  }

  setNoteDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.note_date = null;
    }
    if (
      (new Date(this.formatDate(this.datePickerAddNote.currentDate_input))).getTime() > this.datePickerAddNote.maxDate.getTime() ||
      (new Date(this.formatDate(this.datePickerAddNote.currentDate_input))).getTime() < this.datePickerAddNote.minDate.getTime() ||
      (new Date(this.formatDate(this.datePickerAddNote.currentDate_input))).toDateString() === 'Invalid Date'
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.note_date = 'CORE.invalidDate';
      } else {
        this.serverErrorValidate = { note_date: 'CORE.invalidDate' };
      }
      return;
    }
    this.datePickerAddNote.currentDate = new Date(this.formatDate(this.datePickerAddNote.currentDate_input));
    this.newNote.date = this.datePipe.transform(this.formatDate(this.datePickerAddNote.currentDate_input), 'yyyy-MM-dd');
    this.datePickerAddNote.isActive = false;
  }

  setBirthDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.birth = null;
    }
    this.newHorse.birth = this.datePipe
      .transform(date, 'yyyy-MM-dd')
      .replace(/\s/g, 'T');

    var dataLocalPipe = this.dateLocalPipe.transform(this.newHorse.birth);
    this.datePicker.currentDate = dataLocalPipe;
    this.datePicker.currentDate_input = this.datePipe.transform(dataLocalPipe, environment.dateFormat);
  }

  setBirthDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.birth = null;
    }
    if (
      (new Date(this.formatDate(this.datePicker.currentDate_input))).getTime() > this.datePicker.maxDate.getTime() ||
      (new Date(this.formatDate(this.datePicker.currentDate_input))).getTime() < this.datePicker.minDate.getTime() ||
      (new Date(this.formatDate(this.datePicker.currentDate_input))).toDateString() === 'Invalid Date'
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.birth = 'CORE.invalidDate';
      } else {
        this.serverErrorValidate = { birth: 'CORE.invalidDate' };
      }
      return;
    }
    this.newHorse.birth = this.datePipe.transform(this.formatDate(this.datePicker.currentDate_input), 'yyyy-MM-dd');
    this.datePicker.currentDate = new Date(this.formatDate(this.datePicker.currentDate_input));
    this.datePicker.isActive = false;
  }

  setVaccinationDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.vaccination_date = null;
    }

    this.newVaccination.date = this.datePipe
      .transform(date, 'yyyy-MM-dd')
      .replace(/\s/g, 'T');
    this.datePicker.currentDate = date;
    this.datePicker3.currentDate_input = this.datePipe.transform(date, environment.dateFormat);
    this.datePicker5.minDate = date;
  }


  setVaccinationDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.vaccination_date = null;
    }
    // (new Date(this.formatDate(this.datePicker3.currentDate_input))).getTime() > this.datePicker3.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker3.currentDate_input))).getTime() < this.datePicker3.minDate.getTime() ||
    if (
      (new Date(this.formatDate(this.datePicker3.currentDate_input))).toDateString() === 'Invalid Date'
    ) {
      this.invalidVaccinationForm = true;
      this.newVaccination.date = null;
      this.datePicker3.currentDate = null;
      if (this.serverErrorValidate) {
        this.serverErrorValidate.vaccination_date = 'CORE.invalidDate';
      } else {
        this.serverErrorValidate = { vaccination_date: 'CORE.invalidDate' };
      }
      return;
    }
    this.newVaccination.date = this.datePipe.transform(this.formatDate(this.datePicker3.currentDate_input), 'yyyy-MM-dd');
    this.datePicker3.currentDate = new Date(this.formatDate(this.datePicker3.currentDate_input));
    this.datePicker3.isActive = false;
  }

  removeVaccinationDate() {
    this.newVaccination.date = undefined;
    this.datePicker3.currentDate_input = undefined;
    this.datePicker.currentDate = undefined;
    this.datePicker5.minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 3));
  }

  setNextVaccinationDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.immunization = null;
    }
    this.newVaccination.immunization = this.datePipe
      .transform(date, 'yyyy-MM-dd')
      .replace(/\s/g, 'T');
    this.datePicker5.currentDate = date;
    this.datePicker5.currentDate_input = this.datePipe.transform(date, environment.dateFormat);
    this.datePicker3.maxDate = date;
  }

  setNextVaccinationDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.immunization = null;
    }
    // (new Date(this.formatDate(this.datePicker5.currentDate_input))).getTime() > this.datePicker5.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker5.currentDate_input))).getTime() < this.datePicker5.minDate.getTime() ||
    if (
      (new Date(this.formatDate(this.datePicker5.currentDate_input))).toDateString() === 'Invalid Date'
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.immunization = 'CORE.invalidDate';
      } else {
        this.serverErrorValidate = { immunization: 'CORE.invalidDate' };
      }
      return;
    }
    this.newVaccination.immunization = this.datePipe.transform(this.formatDate(this.datePicker5.currentDate_input), 'yyyy-MM-dd');
    this.datePicker5.currentDate = new Date(this.formatDate(this.datePicker5.currentDate_input));
    this.datePicker5.isActive = false;
  }

  removeNextVaccinationDate() {
    this.newVaccination.immunization = undefined;
    this.datePicker5.currentDate_input = undefined;
    this.datePicker.currentDate = undefined;
    this.datePicker3.maxDate = new Date(new Date().setFullYear(new Date().getFullYear() + 3));
  }

  /**
 * Check validity of period and disabled "Pick date" button
 * @returns {void}
 */
  checknewVaccinationValidity(): void {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    if (this.newVaccination.date && this.newVaccination.immunization && this.newVaccination.date > this.newVaccination.immunization) {
      this.dateRangeErrorMessage = {
        from: 'OTHER.adminGreaterNextAdmin',
        due: 'OTHER.adminGreaterNextAdmin'
      };
      this.invalidVaccinationForm = true;
    }
    // else if (new Date(this.newVaccination.date).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeErrorMessage = {
    //         from: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidVaccinationForm = true;
    // } else if (new Date(this.newVaccination.immunization).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeErrorMessage = {
    //         due: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidVaccinationForm = true;
    // }
    else {
      this.dateRangeErrorMessage = {};
      this.invalidVaccinationForm = false;
    }
  }

  /**
 * Check validity of period and disabled "Pick date" button
 * @returns {void}
 */
  checkEditTreatmentValidity(): void {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    if (this.newTreatment.start_date && this.newTreatment.withdrawal && this.newTreatment.start_date > this.newTreatment.withdrawal) {
      this.dateRangeEditTreatmentErrorMessage = {
        from: 'OTHER.startDateGraterEndDate',
        due: 'OTHER.startDateGraterEndDate'
      };
      this.invalidTreatmentForm = true;
    }
    // else if (new Date(this.newTreatment.start_date).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeEditTreatmentErrorMessage = {
    //         from: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidTreatmentForm = true;
    // } else if (new Date(this.newTreatment.withdrawal).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeEditTreatmentErrorMessage = {
    //         due: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidTreatmentForm = true;
    // }
    else {
      this.dateRangeEditTreatmentErrorMessage = {};
      this.invalidTreatmentForm = false;
    }
  }

  resetDates() {
    this.removeVaccinationDate();
    this.removeNextVaccinationDate();
  }

  setWithdrawal(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.withdrawal = null;
    }

    this.newTreatment.withdrawal = this.datePipe
      .transform(date, 'yyyy-MM-dd')
      .replace(/\s/g, 'T');
    this.datePicker2.currentDate = date;
    this.datePicker4.maxDate = date;
    this.datePicker2.currentDate_input = this.datePipe.transform(date, environment.dateFormat);
  }

  setWithdrawalInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.withdrawal = null;
    }
    // (new Date(this.formatDate(this.datePicker2.currentDate_input))).getTime() > this.datePicker2.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker2.currentDate_input))).getTime() < this.datePicker2.minDate.getTime() ||
    if (
      (new Date(this.formatDate(this.datePicker2.currentDate_input))).toDateString() === 'Invalid Date'
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.withdrawal = 'CORE.invalidDate';
      } else {
        this.serverErrorValidate = { withdrawal: 'CORE.invalidDate' };
      }
      return;
    }
    this.datePicker2.currentDate = new Date(this.formatDate(this.datePicker2.currentDate_input));
    this.newTreatment.withdrawal = this.datePipe.transform(this.formatDate(this.datePicker2.currentDate_input), 'yyyy-MM-dd');
    this.datePicker2.isActive = false;
  }

  setStartDate(date) {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.start_date = null;
    }
    this.newTreatment.start_date = this.datePipe
      .transform(date, 'yyyy-MM-dd')
      .replace(/\s/g, 'T');
    this.datePicker4.currentDate = date;
    this.datePicker2.minDate = date;
    this.datePicker4.currentDate_input = this.datePipe.transform(date, environment.dateFormat);
  }

  setStartDateInput() {
    if (this.serverErrorValidate) {
      this.serverErrorValidate.start_date = null;
    }
    // (new Date(this.formatDate(this.datePicker4.currentDate_input))).getTime() > this.datePicker4.maxDate.getTime() ||
    // (new Date(this.formatDate(this.datePicker4.currentDate_input))).getTime() < this.datePicker4.minDate.getTime() ||
    if (
      (new Date(this.formatDate(this.datePicker4.currentDate_input))).toDateString() === 'Invalid Date'
    ) {
      if (this.serverErrorValidate) {
        this.serverErrorValidate.start_date = 'CORE.invalidDate';
      } else {
        this.serverErrorValidate = { start_date: 'CORE.invalidDate' };
      }
      return;
    }
    this.datePicker4.currentDate = new Date(this.formatDate(this.datePicker4.currentDate_input));
    this.newTreatment.start_date = this.datePipe.transform(this.formatDate(this.datePicker4.currentDate_input), 'yyyy-MM-dd');
    this.datePicker4.isActive = false;
  }

  /**
   * Check validity of period and disabled "Pick date" button
   * @returns {void}
   */
  checknewTreatmentValidity(): void {
    const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
    if (this.newTreatment.start_date && this.newTreatment.withdrawal && this.newTreatment.start_date > this.newTreatment.withdrawal) {
      this.dateRangeTreatmentErrorMessage = {
        from: 'OTHER.startDateGraterEndDate',
        due: 'OTHER.startDateGraterEndDate'
      };
      this.invalidTreatmentForm = true;
    }
    // else if (new Date(this.newTreatment.start_date).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeTreatmentErrorMessage = {
    //         from: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidTreatmentForm = true;
    // } else if (new Date(this.newTreatment.withdrawal).getTime() < new Date(this.appMemory.user.created_at).getTime()) {
    //     this.dateRangeTreatmentErrorMessage = {
    //         due: `OTHER.dateExceededReg`,
    //         date: new Date(this.appMemory.user.created_at).toLocaleString('en-GB', options)
    //     };
    //     this.invalidTreatmentForm = true;
    // }
    else {
      this.dateRangeTreatmentErrorMessage = {};
      this.invalidTreatmentForm = false;
    }
  }

  getFarmSuggestion(variant: any) {
    this._searchStream.next(variant);
  }

  updateHorse(form: any) {
    if (form.form.invalid || !this.newHorse.gender_id) {
      return;
    }

    const ass =
      this.appMemory.user &&
      this.appMemory.user.roles &&
      this.appMemory.user.roles.length > 0 &&
      this.appMemory.user.roles[0].id === 2;
    const formData: FormData = new FormData();

    formData.append('gender_id', this.newHorse.gender_id);
    formData.append('name', this.newHorse.name);
    formData.append('birth', this.newHorse.birth);
    if (this.newHorse.description) {
      formData.append('description', this.newHorse.description);
    }
    formData.append('farm_id', this.newHorse.farm_id);
    formData.append('is_in_food_chain', this.newHorse.is_in_food_chain ? 1 : 0);
    formData.append('in_training', this.newHorse.in_training ? 1 : 0);
    formData.append('microchip_number', this.newHorse.microchip_number);
    let needsS3Upload = false;
    const microchipFiles = [{ file: this.newHorse.microchip }];
    if (this.newHorse.microchip && this.isMicrochipChanged) {
      needsS3Upload = this.storage.appendFilesToForm(
        formData, 'microchip', microchipFiles, { update_image: true });
    }

    if (!this.newHorse.microchip && this.isMicrochipChanged) {
      this.getService.removeMicrochip(this.horse.id, ass).then(
        (res: any) => {
          console.log('img deleted!');
        },
        (err: any) => {
          console.log('img deleting error!');
        }
      );
    }

    this.isRequestInProgress = true;

    this.getService.updateHorse(this.horse.id, formData, ass)
      .then((res: any) => {
        if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
          return this.storage.putToS3(res.presigned_urls, microchipFiles).then(() => res);
        }
        return res;
      })
      .then((res: any) => {
        this.isRequestInProgress = false;
        this.isMicrochipChanged = false;
        this.clearUserInput(this.updateHorseForm);
        this.hideModal();
        this.getFarms();

        if (ass) {
          this.getHorseByUserRole();
        } else {
          this.getHorse();
        }

        this.notificationsService.success(
          `${this.translation['editHorse']}`,
          `${this.translation['horse']} ${this.translation['edittedSuccess']}`
        );
      })
      .catch((err: any) => {
        this.isRequestInProgress = false;
        this.notificationsService.error(
          `${this.translation['editHorse']}`,
          `${this.translation['errorOccurred']}`
        );
        this.serverError = this.objectToArray(JSON.parse(err._body));
      });
  }

  createTreatment(role: string, form: any) {
    if (
      !this.hasNoTreatment &&
      (form.form.invalid ||
        !this.newTreatment.drug ||
        !this.newTreatment.route ||
        !this.newTreatment.start_date ||
        !this.newTreatment.withdrawal ||
        !this.newTreatment.quantity_measure)
    ) {
      return;
    }

    // Same as createNote: the type picker can differ from the active tab.
    if (this.isFormAlreadyEligibleCheckByType(this.newTreatment.type || this.selectedTab)) {
      return;
    }

    this.isRequestInProgress4 = true;

    const formData: FormData = new FormData();

    formData.append('type', this.newTreatment.type || this.selectedTab);
    formData.append('horse_id[0]', this.horse.id);

    if (this.newTreatment.drug && this.newTreatment.drug.id) {
      formData.append('drug_id', this.newTreatment.drug.id);
    }

    // if (!this.newTreatment.drug || !this.newTreatment.drug.id) {
    //   formData.append("drug_name", this.newTreatment.drug_name);
    //   formData.append("drug_brand", this.newTreatment.drug_brand);
    // }

    if (!this.newTreatment.drug || !this.newTreatment.drug.id) {
      formData.append('drug_name', this.newTreatment.drug_name);
    }

    formData.append('route', this.newTreatment.route);

    if (
      this.newTreatment.route &&
      this.newTreatment.route.toLowerCase() === RouteTypes.other
    ) {
      formData.append('other_route', this.newTreatment.other_route);
    }

    if (
      this.newTreatment.route &&
      this.newTreatment.route.toLocaleLowerCase() ===
      RouteTypes.intraArticular
    ) {
      formData.append(
        "intra_articular_infoA",
        this.newTreatment.intra_articular_infoA
      );
      formData.append(
        "intra_articular_infoB",
        this.newTreatment.intra_articular_infoB
      );

      if (
        this.newTreatment.intra_articular_infoB &&
        this.newTreatment.intra_articular_infoB ===
        IntraArticularAdditionalInfoB.other
      ) {
        formData.append(
          "intra_articular_other_info",
          this.newTreatment.intra_articular_other_info
        );
      }
    }


    if (this.newTreatment.route !== RouteTypes.noTreatment) {
      formData.append('reason', this.newTreatment.reason);
      formData.append('start_date', this.newTreatment.start_date);
      formData.append('withdrawal', this.newTreatment.withdrawal);
      formData.append('quantity', this.newTreatment.quantity);
      formData.append('other_quantity', (this.newTreatment.other_quantity));
      formData.append('quantity_measure', this.newTreatment.quantity_measure);
      /*formData.append("detection_time", this.newTreatment.detection_time);*/
      // formData.append('duration', this.newTreatment.duration);
    }

    let needsS3Upload = false;
    if (this.newTreatment.src && this.isImagesChanged) {
      const imgs = $('.with_description .image-container .image');
      this.newTreatment.src.forEach((e, i) => {
        formData.append(
          'images[' + i + '][description]',
          $(imgs[i])
            .find('input')
            .val()
        );
      });
      needsS3Upload = this.storage.appendFilesToForm(
        formData, 'images', this.newTreatment.src, null, true);
    }

    switch (this.appMemory.user.roles[0].id) {
      case 1:
        this.getService.createTreatment(role, formData)
          .then((res: any) => {
            if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
              return this.storage.putToS3(res.presigned_urls, this.newTreatment.src).then(() => res);
            }
            return res;
          })
          .then((res: any) => {
            this.clearUserInput(this.createTreatmentForm);
            this.treatmentsByDate = [];
            this.treatmentsByDateArchive = [];
            this.isRequestInProgress4 = false;
            this.getHorse('/treatments', this.selectedTab);
            this.notificationsService.success(
              `${this.translation['addTreat']}`,
              `${this.translation['treatment']} ${this.translation['addedSuccess']}`
            );
            this.hideModal();
          })
          .catch((err: any) => {
            console.log('ERR', err);
            this.isRequestInProgress4 = false;
            this.notificationsService.error(
              `${this.translation['addTreat']}`,
              `${this.translation['errorOccurred']}`
            );
            this.serverError = this.objectToArray(JSON.parse(err._body));
          });
        break;

      case 2:
        this.getService.createTreatmentA(role, formData, [this.horse.id])
          .then((res: any) => {
            if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
              return this.storage.putToS3(res.presigned_urls, this.newTreatment.src).then(() => res);
            }
            return res;
          })
          .then((res: any) => {
            this.clearUserInput(this.createTreatmentForm);
            this.treatmentsByDate = [];
            this.treatmentsByDateArchive = [];
            this.isRequestInProgress4 = false;
            this.getHorse('/treatments', this.selectedTab);
            this.notificationsService.success(
              `${this.translation['addTreat']}`,
              `${this.translation['treatment']} ${this.translation['addedSuccess']}`
            );
            this.hideModal();
          })
          .catch((err: any) => {
            this.isRequestInProgress4 = false;
            this.notificationsService.error(
              `${this.translation['addTreat']}`,
              `${this.translation['errorOccurred']}`
            );
            this.serverError = this.objectToArray(JSON.parse(err._body));
          });
        break;

      case 3:
        this.getService
          .createTreatmentV(
            role,
            formData,
            [this.horse.id],
            this.horse.instructor_id
          )
          .then((res: any) => {
            if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
              return this.storage.putToS3(res.presigned_urls, this.newTreatment.src).then(() => res);
            }
            return res;
          })
          .then(
            (res: any) => {
              this.clearUserInput(this.createTreatmentForm);
              this.treatmentsByDate = [];
              this.treatmentsByDateArchive = [];
              this.isRequestInProgress4 = false;
              this.getHorse('/treatments', this.selectedTab);
              this.notificationsService.success(
                `${this.translation['addTreat']}`,
                `${this.translation['treatment']} ${this.translation['addedSuccess']}`
              );
              this.hideModal();
            }
          )
          .catch((err: any) => {
              console.log('ERR', err);
              this.isRequestInProgress4 = false;
              this.notificationsService.error(
                `${this.translation['addTreat']}`,
                `${this.translation['errorOccurred']}`
              );
              this.serverError = this.objectToArray(JSON.parse(err._body));
            }
          );
        break;
    }
  }

  createQuickTreatment(role: string, form: any) {
    if (!this.newTreatment.src || !this.newTreatment.src.length) {
      return;
    }
    this.isRequestInProgress4 = true;

    const formData: FormData = new FormData();

    formData.append('horses_id[0]', this.horse.id);

    let needsS3Upload = false;
    if (this.newTreatment.src && this.isImagesChanged) {
      const imgs = $('.with_description .image-container .image');
      this.newTreatment.src.forEach((e, i) => {
        formData.append(
          'images[' + i + '][description]',
          $(imgs[i])
            .find('input')
            .val()
        );
      });
      needsS3Upload = this.storage.appendFilesToForm(
        formData, 'images', this.newTreatment.src, null, true);
    }

    this.getService.createQuickTreatment(role, formData)
      .then((res: any) => {
        if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
          return this.storage.putToS3(res.presigned_urls, this.newTreatment.src).then(() => res);
        }
        return res;
      })
      .then((res: any) => {
        this.clearUserInput(this.createTreatmentForm);
        this.treatmentsByDate = [];
        this.treatmentsByDateArchive = [];
        this.isRequestInProgress4 = false;
        this.getHorse('/treatments', this.createTreatmentForm.type);
        this.notificationsService.success(
          `${this.translation['addTreat']}`,
          `${this.translation['treatment']} ${this.translation['addedSuccess']}`
        );
        this.hideModal();
      })
      .catch((err: any) => {
        this.isRequestInProgress4 = false;
        this.notificationsService.error(
          `${this.translation['addTreat']}`,
          `${this.translation['errorOccurred']}`
        );
        this.serverError = this.objectToArray(JSON.parse(err._body));
      });
  }

  updateTreatment(role: string, form: any) {
    if (
      !this.hasNoTreatment &&
      (form.form.invalid ||
        !this.newTreatment.drug ||
        !this.newTreatment.start_date ||
        !this.newTreatment.withdrawal ||
        !this.newTreatment.quantity_measure ||
        !this.isTreatmentEditable(this.newTreatment))
    ) {
      return;
    }

    this.isRequestInProgress4 = true;

    const formData: FormData = new FormData();

    formData.append('horse_id', this.horse.id);
    formData.append('type', this.newTreatment.type);

    if (this.newTreatment.drug && this.newTreatment.drug.id) {
      formData.append('drug_id', this.newTreatment.drug.id);
    }

    // if (!this.newTreatment.drug || !this.newTreatment.drug.id) {
    //   formData.append("drug_name", this.newTreatment.drug_name);
    //   formData.append("drug_brand", this.newTreatment.drug_brand);
    // }

    if (!this.newTreatment.drug || !this.newTreatment.drug.id) {
      formData.append('drug_name', this.newTreatment.drug_name);
    }

    formData.append('route', this.newTreatment.route);

    if (
      (this.newTreatment.route &&
        this.newTreatment.route.toLowerCase() === RouteTypes.other)
    ) {
      formData.append('other_route', this.newTreatment.other_route);
    }

    if (
      this.newTreatment.route &&
      this.newTreatment.route.toLocaleLowerCase() ===
      RouteTypes.intraArticular
    ) {
      formData.append(
        "intra_articular_infoA",
        this.newTreatment.intra_articular_infoA
      );
      formData.append(
        "intra_articular_infoB",
        this.newTreatment.intra_articular_infoB
      );

      if (
        this.newTreatment.intra_articular_infoB &&
        this.newTreatment.intra_articular_infoB ===
        IntraArticularAdditionalInfoB.other
      ) {
        formData.append(
          "intra_articular_other_info",
          this.newTreatment.intra_articular_other_info
        );
      }
    }

    if (this.newTreatment.route !== RouteTypes.noTreatment) {
      formData.append('reason', this.newTreatment.reason);
      formData.append('start_date', this.newTreatment.start_date);
      formData.append('withdrawal', this.newTreatment.withdrawal);
      formData.append('quantity', this.newTreatment.quantity);
      formData.append('other_quantity', (this.newTreatment.other_quantity || ''));
      formData.append('quantity_measure', this.newTreatment.quantity_measure);
      /*formData.append("detection_time", this.newTreatment.detection_time);*/
      //formData.append('duration', this.newTreatment.duration);
    }

    if (this.newTreatment.prescriptions[0].images) {
      const del = [];
      this.newTreatment.prescriptions[0].images.forEach(el => {
        let flag = true;
        this.newTreatment.srcs.forEach(el2 => {
          if (flag && el2.id === el.id) {
            flag = false;
          }
        });
        if (flag) {
          del.push(el.id);
        }
      });
      if (del.length > 0) {
        const requestObj = {};
        switch (role) {
          case '/vet':
            requestObj['url'] =
              '/treatment-request-vet/' + this.newTreatment.id;
            break;
          case '/assistant':
            requestObj['url'] = '/treatment-request/' + this.newTreatment.id;
            break;
          case '/instructor':
            requestObj['url'] = '/instructor/treatment/' + this.newTreatment.id;
            break;
        }
        requestObj['params'] = { 'images[]': del };
        this.getService.removeImages(requestObj).then(
          res => {
            this.getHorseByUserRole();
          },
          err => {
            console.log(err);
          }
        );
      }
    }

    let needsS3Upload = false;
    if (this.newTreatment.src && this.isImagesChanged) {
      const imgs = $('.with_description .image-container .image');
      this.newTreatment.src.forEach((e, i) => {
        formData.append(
          'images[' + i + '][description]',
          $(imgs[i])
            .find('input')
            .val()
        );
      });
      needsS3Upload = this.storage.appendFilesToForm(
        formData, 'images', this.newTreatment.src, null, true);
    }

    switch (this.appMemory.user.roles[0].id) {
      case 1:
        this.getService
          .updateTreatment(role, formData, this.newTreatment.id)
          .then((res: any) => {
            if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
              return this.storage.putToS3(res.presigned_urls, this.newTreatment.src).then(() => res);
            }
            return res;
          })
          .then(
            (res: any) => {
              this.clearUserInput(this.updateTreatmentForm);
              this.getHorseByUserRole();
              this.isRequestInProgress4 = false;
              this.notificationsService.success(
                `${this.translation['editTreat']}`,
                `${this.translation['treatment']} ${this.translation['edittedSuccess']}`
              );
              this.hideModal();
            }
          )
          .catch((err: any) => {
              this.isRequestInProgress4 = false;
              this.notificationsService.error(
                `${this.translation['editTreat']}`,
                `${this.translation['errorOccurred']}`
              );
              this.serverError = this.objectToArray(JSON.parse(err._body));
            }
          );
        break;

      case 2:
        this.getService
          .updateTreatmentA(role, formData, this.newTreatment.id)
          .then((res: any) => {
            if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
              return this.storage.putToS3(res.presigned_urls, this.newTreatment.src).then(() => res);
            }
            return res;
          })
          .then(
            (res: any) => {
              this.clearUserInput(this.updateTreatmentForm);
              this.getHorseByUserRole();
              this.isRequestInProgress4 = false;
              this.notificationsService.success(
                `${this.translation['editTreat']}`,
                `${this.translation['treatment']} ${this.translation['edittedSuccess']}`
              );
              this.hideModal();
            }
          )
          .catch((err: any) => {
              this.isRequestInProgress4 = false;
              this.notificationsService.error(
                `${this.translation['editTreat']}`,
                `${this.translation['errorOccurred']}`
              );
              this.serverError = this.objectToArray(JSON.parse(err._body));
            }
          );
        break;

      case 3:
        this.getService
          .updateTreatmentV(role, formData, this.newTreatment.id)
          .then((res: any) => {
            if (needsS3Upload && res.presigned_urls && res.presigned_urls.length) {
              return this.storage.putToS3(res.presigned_urls, this.newTreatment.src).then(() => res);
            }
            return res;
          })
          .then(
            (res: any) => {
              this.clearUserInput(this.updateTreatmentForm);
              this.getHorseByUserRole();
              this.isRequestInProgress4 = false;
              this.notificationsService.success(
                `${this.translation['editTreat']}`,
                `${this.translation['treatment']} ${this.translation['edittedSuccess']}`
              );
              this.hideModal();
            }
          )
          .catch((err: any) => {
              this.isRequestInProgress4 = false;
              this.notificationsService.error(
                `${this.translation['editTreat']}`,
                `${this.translation['errorOccurred']}`
              );
              this.serverError = this.objectToArray(JSON.parse(err._body));
            }
          );
        break;
    }
  }

  proceessTreatment(treatment: Treatment, form?: any) {
    if (form && form.form.invalid) {
      return;
    }

    if (!this.treatmentStatus.comment) {
      this.treatmentStatus.comment = undefined;
    }

    switch (this.treatmentStatus.status) {
      case 'approved':
        this.treatmentStatus.comment = undefined;
        this.treatmentStatus.vetclinic_id = 1;
        break;

      case 'cancelled':
        this.treatmentStatus.vetclinic_id = undefined;
        break;
    }

    this.getService
      .proceessTreatment(this.treatmentStatus.request_id, this.treatmentStatus)
      .then(
        (res: any) => {
          if (form) {
            this.clearUserInput(form);
          }

          this.hideModal();
          this.getHorseByUserRole();
          this.notificationsService.success(
            `${this.translation['updateTreatmentStatus']}`,
            `${this.translation['treatmentStatus']} ${this.translation['updatedSuccess']}`
          );
        },
        (err: any) => {
          // console.log('ERR', err);
          this.isRequestInProgress = false;
          this.notificationsService.error(
            `${this.translation['updateTreatmentStatus']}`,
            `${this.translation['errorOccurred']}`
          );
          this.serverError = this.objectToArray(JSON.parse(err._body));
        }
      );
  }

  changeTreatmentStatus(id: number, body: any) {
    this.getService.changeTreatmentStatus(id, body).then(
      (res: any) => {
        this.hideModal();
        this.getHorseByUserRole();
        this.notificationsService.success(
          `${this.translation['closeTreatment']}`,
          `${this.translation['archivedSuccess']}`
        );
      },
      (err: any) => {
        console.log('ERR', err);
        this.isRequestInProgress = false;
        this.notificationsService.error(
          `${this.translation['closeTreatment']}`,
          `${this.translation['errorOccurred']}`
        );
        this.serverError = this.objectToArray(JSON.parse(err._body));
      }
    );
  }

  cloneTreatment(treatment: Treatment) {
    this.newTreatment = Object.assign({}, treatment);
    this.hasNoTreatment = this.newTreatment.route === RouteTypes.noTreatment;
    this.serverErrorValidate = null;

    this.datePicker4.currentDate_input = this.datePipe.transform(this.newTreatment.start_date, environment.dateFormat);
    this.datePicker4.currentDate = (new Date(this.newTreatment.start_date));

    this.datePicker2.currentDate_input = this.datePipe.transform(this.newTreatment.withdrawal, environment.dateFormat);
    this.datePicker2.currentDate = (new Date(this.newTreatment.withdrawal));
    if (
      this.newTreatment.prescriptions &&
      this.newTreatment.prescriptions[0].drugs[0]
    ) {
      this.newTreatment.drug = this.newTreatment.prescriptions[0].drugs[0];
    } else {
      this.newTreatment.drug = {
        // 'brand': '',
        created_at: null,
        id: 0,
        name: 'Other',
        updated_at: null,
      };
    }


    this.newTreatment.other_quantity = this.newTreatment.prescriptions[0].other_quantity || '';
    this.newTreatment.quantity = this.newTreatment.prescriptions[0].quantity;
    this.newTreatment.quantity_measure = this.newTreatment.prescriptions[0].quantity_measure;
    this.newTreatment.duration = this.newTreatment.prescriptions[0].duration;
    /*this.newTreatment.detection_time = this.newTreatment.detection_time;*/
    this.newTreatment.srcs = [];

    this.newTreatment.prescriptions[0].images.forEach(el => {
      this.newTreatment.srcs.push(Object.assign({}, el));
    });

    const items = this.appMemory.measures;
    const quantity = this.newTreatment.quantity_measure;

    this.measuresSelectorModel = [
      items.find(function (obj) {
        return obj.text === quantity;
      }),
    ];

    this.calcMaxLength(this.newTreatment.quantity);
  }

  normalizeNote(note) {
    const result = Object.assign({}, note);
    const comments = (result.info || {} as NoteInfo).comments || {};

    Object.keys(comments || {}).forEach(k => {
      result['comments[' + k + ']'] = comments[k];
    });

    return result;
  }

  setNote(note) {
    this.hideModal();
    this.newNote = Object.assign({}, note);
    const comments = (note.info || {} as NoteInfo).comments || {};

    Object.keys(comments || {}).forEach(k => {
      this.newNote['comments[' + k + ']'] = comments[k];
    });

    if (!this.newNote.weight) {
      delete this.newNote.weight;
    }

    this.newNote.srcs = [];

    note.images.forEach(el => {
      this.newNote.srcs.push(Object.assign({}, el));
    });
    setTimeout(() => {
      if (note.images) {
        // this.imageLoader24.files[0] = new File([''], 'microchip');
        // this.imageLoader24.files[0].src = note.images;
        // this.imageLoader24.fileChange(this.imageLoader24.files[0]);
        // this.imageLoader24.fileCounter = 1;
      }
    });

    this.datePickerAddNote.currentDate = this.newNote.date ? (new Date(this.newNote.date)) : new Date();
    this.datePickerAddNote.currentDate_input = this.datePipe.transform(this.newNote.date, environment.dateFormat);

    if (this.newNote.weight) {
      const items = this.appMemory.weights;
      const weight = this.newNote.weight;

      this.weightsSelectorModel = [
        items.find(function (obj) {
          return obj.text === weight;
        }),
      ];
    }
  }

  createFinalVaccination() {
    this.getService
      .addVaccination(
        this.activatedRoute.params['value']['horse_id'],
        this.newVaccination
      )
      .then(
        (res: any) => {
          $('#assistant-invite-email-box').removeClass('input--filled');
          this.clearUserInput();
          this.hideModal();
          this.vaccinations = [];
          this.getHorseByUserRole();
          this.isRequestInProgress = false;
          this.notificationsService.success(
            `${this.translation['addVacs']}`,
            `${this.translation['vacc']} ${this.translation['addedSuccess']}`
          );
        },
        (err: any) => {
          console.log('ERR', err);
          if (JSON.parse(err._body).error === 'isBoosterOutsideOfDates') {
            document.getElementById('modal-vaccination-link').click();
          } else {
            this.isRequestInProgress = false;

            if (err.status === 422) {
              this.notificationsService.error(
                `${this.translation['addVacs']}`,
                JSON.parse(err._body).error
                  ? JSON.parse(err._body).error
                  : `${this.translation['errorOccurred']}`
              );

              return;
            }

            this.notificationsService.error(
              `${this.translation['addVacs']}`,
              `${this.translation['errorOccurred']}`
            );
          }
        }
      );
  }

  switchFromBoosterToPrimary() {
    this.newVaccination.number = 'primary';
    this.createFinalVaccination();
  }

  reasignHorse() {
    this.newHorse = Object.assign({}, this.horse);
    this.farmSelectModelLoaded = false;

    this.farmSelectModel[0]['id'] = this.newHorse.farm.id;
    this.farmSelectModel[0]['text'] = this.newHorse.farm.name;

    this.farmSelectModelLoaded = true;

    setTimeout(() => {
      if (this.horse.microchip) {
        this.imageLoader.files[0] = new File([''], 'microchip');
        this.imageLoader.files[0].src = this.horse.microchip;
        this.imageLoader.fileChange(this.imageLoader.files[0]);
        this.imageLoader.fileCounter = 1;
      }
    });

    this.updateHorseForm._submitted = false;
  }

  getVaccinations() {
    this.isRequestInProgress5 = true;
    this.getService
      .getVaccinations(this.activatedRoute.params['value']['horse_id'])
      .then(
        (res: any) => {
          this.vaccinations = res.data;

          if (res.next_page_url) {
            this.paginationVc.nextPage = res.next_page_url;
          } else {
            this.paginationVc.nextPage = res.next_page_url;
          }

          this.isRequestInProgress5 = false;
        },
        (err: any) => {
          console.log('ERR', err);
          this.isRequestInProgress5 = false;
        }
      );
  }

  createVaccination(form: any) {
    if (
      form.form.invalid ||
      !this.newVaccination.date ||
      (!this.newVaccination.other && !this.newVaccination.number) ||
      (this.newVaccination.other &&
        ((this.newVaccination.other && !this.newVaccination.immunization) ||
          !this.newVaccination.name))
    ) {
      this.invalidVaccinationForm = true;
      return;
    }

    this.isRequestInProgress = true;

    // const body = Object.assign({}, this.newVaccination);
    this.createFinalVaccination();


  }

  removeVaccination(form: any) {
    this.isRequestInProgress = true;

    this.getService
      .removeVaccination(
        this.activatedRoute.params['value']['horse_id'],
        this.currentVaccination.id
      )
      .then(
        (res: any) => {
          $('#assistant-invite-email-box').removeClass('input--filled');
          this.clearUserInput(form);
          this.hideModal();
          this.vaccinations = [];
          this.getHorseByUserRole();
          this.isRequestInProgress = false;
          this.notificationsService.success(
            `${this.translation['delectVacc']}`,
            `${this.translation['vacc']} ${this.translation['deletedSuccess']}`
          );
        },
        (err: any) => {
          console.log('ERR', err);
          this.isRequestInProgress = false;
          this.notificationsService.error(
            `${this.translation['delectVacc']}`,
            `${this.translation['errorOccurred']}`
          );
        }
      );
  }

  archiveHorse(form: any) {
    this.isRequestInProgress = true;

    this.getService
      .archiveHorse(this.activatedRoute.params['value']['horse_id'])
      .then(
        (res: any) => {
          $('#assistant-invite-email-box').removeClass('input--filled');
          this.clearUserInput(form);
          this.hideModal();
          this.vaccinations = [];
          this.getHorseByUserRole();
          this.isRequestInProgress = false;
          this.notificationsService.success(
            `${this.translation['archiveHorse']}`,
            `${this.translation['horse']} archived successfully`
          );
        },
        (err: any) => {
          console.log('ERR', err);
          this.isRequestInProgress = false;
          this.notificationsService.error(
            `${this.translation['archiveHorse']}`,
            `${this.translation['errorOccurred']}`
          );
        }
      );
  }

  deleteTreatment(form: any) {
    this.isRequestInProgress = true;

    const role = this.appMemory.roles[this.appMemory.user.roles[0].id];

    this.getService
      .deleteTreatment(
        this.currentTreatment ? this.currentTreatment.id : this.newTreatment.id,
        role
      )
      .then(
        (res: any) => {
          this.clearUserInput(form);
          this.hideModal();
          this.getHorseByUserRole();
          this.isRequestInProgress = false;
          this.notificationsService.success(
            `${this.translation['deleteTreat']}`,
            `${this.translation['treatment']} ${this.translation['deletedSuccess']}`
          );
        },
        (err: any) => {
          console.log('ERR', err);
          this.isRequestInProgress = false;

          if (err.status === 404) {
            this.clearUserInput(form);
            this.hideModal();
            this.getHorseByUserRole();

            this.notificationsService.error(
              `${this.translation['deleteTreat']}`,
              `${this.translation['treatment']} ${this.translation['wasAlreadyDeleted']}`
            );

            return;
          }

          this.notificationsService.error(
            `${this.translation['deleteTreat']}`,
            `${this.translation['errorOccurred']}`
          );
        }
      );
  }

  deleteNote(form?: any) {
    this.isRequestInProgress = true;

    const role = this.appMemory.roles[this.appMemory.user.roles[0].id];

    this.getService
      .deleteNote(
        this.activatedRoute.params['value']['horse_id'],
        this.newNote.id,
        role
      )
      .then(
        (res: any) => {
          this.clearUserInput();
          this.hideModal();
          this.getHorseByUserRole();
          this.isRequestInProgress = false;
          this.notificationsService.success(
            `${this.translation['deleteNote']}`,
            `${this.translation['note']} ${this.translation['deletedSuccess']}`
          );
        },
        (err: any) => {
          console.log('ERR', err);
          this.isRequestInProgress = false;

          if (err.status === 404) {
            this.clearUserInput();
            this.hideModal();
            this.getHorseByUserRole();

            this.notificationsService.error(
              `${this.translation['deleteNote']}`,
              `${this.translation['note']} ${this.translation['wasAlreadyDeleted']}`
            );

            return;
          }

          this.notificationsService.error(
            `${this.translation['deleteTreat']}`,
            `${this.translation['errorOccurred']}`
          );
        }
      );
  }

  pad(num, size) {
    try {
      let s = num + '';
      while (s.length < size) {
        s = '0' + s;
      }
      return s;
    } catch (e) {
      return num;
    }
  }

  public isTreatmentEditable(treatment: Treatment): boolean {
    if (!treatment || !treatment.horse || !treatment.horse.is_active || treatment.status === 'closed' ||
      !this.appMemory.user || this.appMemory.user.roles.length === 0 || treatment.horse.is_eligible) {
      return false;
    }

    switch (this.appMemory.user.roles[0].id) {
      case 1: // instrucotr / trainer
        if (environment.disableTreatmentEditInstructorNotOwned) {
          if (treatment.request) {
            return this.appMemory.user.id === treatment.request.user_id;
          } else {
            return true;
          }
        } else {
          return true;
        }
      case 3:     // vet
        if (treatment.request && treatment.request.status === 'approved') {
          return false;
        }
        if (treatment.request) {
          return this.appMemory.user.id === treatment.request.user_id;
        }
    }
    return false;
  }


  generateNoteFields(selectedType?: string): NoteFormField[] {
    const [{ form = [] } = {}] = this.noteTypes.filter(
      ({ type }) => type === (selectedType || this.selectedTab)
    );

    return form;
  }

  setTab(tab: NoteTab | TreatmentTab, type: string = 'treatment') {
    let excludeTreatments;
    let excludeNotes;

    if (type === 'treatment') {
      this.tabs.isNotes = false;
      excludeNotes = true;
      excludeTreatments = false;
      this.tabs.isTreatments = true;
    }

    if (type === 'note') {
      this.tabs.isTreatments = false;
      excludeTreatments = true;
      excludeNotes = false;
      this.tabs.isNotes = true;
    }

    if (this.selectedTab !== tab.type) {
      this.selectedTab = tab.type;
      this.getHorseByUserRole({
        excludeHorse: true,
        excludeTreatments,
        excludeNotes,
      });
    }
  }


  processServerError(err?: any): string {
    const error = err || {};

    try {
      return !err._body
        ? err.message
        : Object.keys(err._body = JSON.parse(err._body))
          .reduce((acc, key) => acc.concat(this.translation[key]), [])
          .toString();
    }
    // tslint:disable-next-line:one-line
    catch (e) {
      return '';
    }
  }

  public setHasNoTreatment(e: Event) {
    this.hasNoTreatment = !this.hasNoTreatment;
    delete this.newTreatment.route;
    if (this.hasNoTreatment) {
      this.newTreatment.route = RouteTypes.noTreatment;
    }
  }


  public setCurrentTreatment(treatment) {
    this.currentTreatment = treatment;
    this.hasNoTreatment = treatment.route === RouteTypes.noTreatment;
    this.debug(treatment);
  }

  isFormAlreadyEligible() {
    if (this.eligible_forms &&
      this.selectedTab &&
      this.eligible_forms[this.selectedTab]) {
      return true;
    }
    return false;
  }

  isFormAlreadyEligibleCheckByType(formType: string) {
    if (this.eligible_forms &&
      this.eligible_forms[formType]) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/horse/horse.component.ts